export default "__VITE_ASSET__BnY4$rCs__"